import {sum, values} from 'lodash'
import {ReactNode, useCallback} from 'react'
import {FoldingProvider} from '../../providers/FoldingProvider'
import {InputProvider} from '../../providers/InputProvider'
import {StepDataProvider} from '../../providers/StepDataProvider'

type RenderProps = {
  onClick: () => void
  disabled: boolean
}

type Props = {
  onClick: () => void
  onError: (error: unknown) => void
  render: (props: RenderProps) => ReactNode
}

export const ApplyButton = ({onClick, onError, render}: Props) => {
  const activeStepCode = FoldingProvider.useActiveStepCode()
  const dataManager = StepDataProvider.useStepDataManager(activeStepCode)
  const unitCounters = InputProvider.useUnitCounters('optional')
  const availabilityId = InputProvider.useAvailabilityId('optional')
  const optionId = InputProvider.useOptionId('optional')

  const resultOnClick = useCallback(() => {
    if (dataManager && !dataManager.isValid()) {
      onError(dataManager.hint)
      return
    }

    onClick()
  }, [onClick, onError, dataManager])

  const disabled = Boolean(sum(values(unitCounters)) === 0 || !availabilityId || !optionId)

  return <>{render({onClick: resultOnClick, disabled})}</>
}
